import { forwardRef } from "react";

export const Input = forwardRef(
    (
        {
            label,
            type,
            value,
            onChange,
            onKeyDown,
            fileName = "",
            options = [],
        },
        ref
    ) => {
        return (
            <div className="w-full mt-3">
                <div className="relative">
                    {type === "select" ? (
                        <select
                            value={value}
                            onChange={onChange}
                            className="peer w-full bg-transparent text-slate-700 text-sm border border-slate-200 rounded-md px-4 py-3 transition duration-300 ease focus:outline-none focus:border-blue-500 hover:border-blue-500 shadow-sm focus:shadow">
                            <option selected value="" disabled>
                                pilih
                            </option>
                            {options.map((option, index) => (
                                <option key={index} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    ) : type === "file" ? (
                        <div className="relative w-full h-[48px]">
                            <input
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                aria-describedby="file_input_help"
                                type="file"
                                onChange={onChange}
                            />
                            <div className="flex items-center justify-between h-full px-4 bg-gray-50 border border-gray-300 rounded-lg">
                                <span className="text-sm text-gray-500">
                                    {fileName}
                                </span>
                                <button
                                    type="button"
                                    className="px-3 py-1 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:outline-none">
                                    Pilih
                                </button>
                            </div>
                        </div>
                    ) : type === "date" ? (
                        <input
                            type="date"
                            value={value}
                            onChange={onChange}
                            className="peer w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-4 py-3 transition duration-300 ease focus:outline-none focus:border-blue-500 hover:border-blue-500 shadow-sm focus:shadow"
                        />
                    ) : (
                        <input
                            ref={ref}
                            type={type}
                            value={value}
                            onChange={onChange}
                            onKeyDown={onKeyDown}
                            className="peer w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-4 py-3 transition duration-300 ease focus:outline-none focus:border-blue-500 hover:border-blue-500 shadow-sm focus:shadow"
                        />
                    )}
                    <label
                        className={`${
                            value
                                ? "-top-2 scale-90 text-blue-500 text-[15px] left-2.5"
                                : "left-2.5 top-3 text-slate-400 text-[14px]"
                        } absolute cursor-text bg-white px-1 transition-all transform origin-left peer-focus:-top-2 peer-focus:left-2.5 peer-focus:text-[15px] peer-focus:text-blue-500 peer-focus:scale-90`}>
                        {label}
                    </label>
                </div>
            </div>
        );
    }
);
